import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../plugins/axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: {},
    site: null,
    user: null,
    languages: []
  },
  mutations: {
      SAVE_LANG(state, items) {
          state.lang = items;
      },
      SAVE_SITE(state, items) {
          state.site = items;
      },
      SAVE_USER(state, items) {
          state.user = items;
      },
      SAVE_LANGUAGES(state, items) {
          state.languages = items
      }
  },
  actions: {
      GET_LANGUAGES({commit, state}) {
          if(state.languages.length) {
              return state.languages
          }
          else{
              console.log('store axios', state.site.id)
              return axios.get('/language', {headers: {Site: state.site.id}}).then(res => {
                  commit('SAVE_LANGUAGES', res.data)
                  return res.data
              })
          }

      }
  },
  modules: {
  }
})
